// 明細検索の結果1行。タップすると元のレシートを開く
import { format } from 'date-fns'

import type { PriceBasis, ReceiptItemSearchResult } from '@/api/types/receipt'
import { Badge } from '@/components/ui/badge'
import { parseUtcDate } from '@/lib/date-utils'

import { formatAmount } from '../field-value'

type Props = {
  item: ReceiptItemSearchResult
  basis: PriceBasis
  onSelectReceipt: (receiptId: number) => void
}

const formatPurchasedAt = (iso: string | null): string => {
  if (!iso) return '日時不明'
  return format(parseUtcDate(iso), 'yyyy/MM/dd')
}

/** 「2個 168円」のように、単価だけでは分からない買い方を補う */
const formatQuantity = (item: ReceiptItemSearchResult): string | null => {
  if (item.quantity === null || item.quantity <= 1) return null
  return `${item.quantity}${item.unit ?? '点'}`
}

export const ReceiptItemRow = ({ item, basis, onSelectReceipt }: Props) => {
  const unitPrice = basis === 'net' ? item.net_unit_price : item.list_unit_price
  const quantity = formatQuantity(item)
  const isDiscounted = item.discount !== null && item.discount > 0

  return (
    <button
      type="button"
      onClick={() => onSelectReceipt(item.receipt_id)}
      className="w-full rounded border border-gray-700 p-3 text-left transition-colors hover:bg-white/5"
    >
      <div className="flex items-baseline justify-between gap-2">
        <span className="min-w-0 flex-1 wrap-break-word">{item.name}</span>
        <span className="shrink-0 font-medium tabular-nums">{formatAmount(unitPrice)}</span>
      </div>
      <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground">
        <span className="min-w-0 truncate">{item.store_name || item.place_name || '店名不明'}</span>
        <span className="tabular-nums">{formatPurchasedAt(item.purchased_at)}</span>
        {quantity && <span className="tabular-nums">{quantity}</span>}
        {isDiscounted && <Badge variant="secondary">値引き</Badge>}
      </div>
    </button>
  )
}
